import BaseSelector from './base';

export default class CustomerData extends BaseSelector {
  prefix = 'customer-data';

  normalizedData = (dataset) => dataset;
}
